import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { InfoUser, UserLogin } from "models/auth";
export interface AuthState {
  isChecked: boolean;
  loading: boolean;
  infoLogin: InfoUser;
  language: string;
}

const initialState: AuthState = {
  loading: false,
  isChecked: false,
  language: "",
  infoLogin: {
    email: "",
    staffId: "",
    name: "",
    area: {
      id: "",
      name: "",
    },
    phone: "",
    province: {
      id: "",
      name: "",
    },
    dateOfJoining: "",
    workType: {
      id: "",
      name: "",
    },
    farm: {
      id: "",
      name: "",
    },
    position: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    fetchIsChecked(state) {
      state.isChecked = !state.isChecked;
      localStorage.setItem('isChecked', String(state.isChecked))
    },
    fetchInfoLogin(state) {
      state.loading = true;
    },
    fetchInfoLoginSuccess(state, action: PayloadAction<InfoUser>) {
      state.infoLogin = action.payload;
      state.loading = false;
    },

    // Change Language
    handleChangeLanguage(state, action: PayloadAction<string>) {
      state.language = action.payload;
    },
  },
});

// action
export const {
  fetchIsChecked,
  fetchInfoLogin,
  fetchInfoLoginSuccess,
  handleChangeLanguage,
} = authSlice.actions;

//Selector
export const selectIsChecked = (state: RootState) => state.authReducer.isChecked;
export const selectInfoLogin = (state: RootState) => state.authReducer.infoLogin;
export const selectInfoLoginLoading = (state: RootState) => state.authReducer.loading;
export const selectLanguage = (state: RootState) => state.authReducer.language;

const authReducer = authSlice.reducer;

export default authReducer;
